import type { MRT_ColumnFiltersState } from "mantine-react-table";

interface KeepKnownColumnFiltersParams {
    columnIds: string[];
    columnFilters: MRT_ColumnFiltersState;
}

export const keepKnownColumnFilters = ({
    columnIds,
    columnFilters,
}: KeepKnownColumnFiltersParams): MRT_ColumnFiltersState => {
    const known = new Set(columnIds);
    return columnFilters.filter((filter) => known.has(filter.id));
};
